import React from 'react'

const Nosotros = () => {
  return (
    <div className="emptyCard">Nosotros</div>
  )
}

export default Nosotros